export const NAV_HEIGHT_MOBILE = '90px';
export const NAV_HEIGHT = '100px';
export const MAX_CONTENT_WIDTH = '1500px';
